import { useState } from "react";
import { useNavigate } from "react-router";

import { Page } from "@digital-services/shell";
import {
  Button,
  Card,
  Input,
  Typography,
  useAlert
} from "@digital-services/ui";

import { apiUsersRoute, editApiUserRouteOnTab1 } from "@api-users/common";
import { useCreateApiUser } from "@api-users/part-1-api-user/services/use-create-api-user";

import { useOrganizationContext } from "@hooks/useOrganizationContext";

export const CreateApiUserPage = () => {
  const navigate = useNavigate();
  const { notifyError, notifySuccess } = useAlert();
  const [apiUserName, setApiUserName] = useState("");
  const [createDisabled, setCreateDisabled] = useState(true);
  const [inProgress, setInProgress] = useState(false);

  const { organization: currentOrganization } = useOrganizationContext();
  const { createApiUser } = useCreateApiUser();

  const onCreateCallback = async () => {
    setCreateDisabled(true); // to avoid frequent clicks/POST requests to server
    setInProgress(true);

    const response = await createApiUser(currentOrganization.id, apiUserName);
    const apiUser = response.data;

    if (response?.isSuccess && apiUser?.id) {
      notifySuccess({
        header: "New API user has been successfully created",
        "data-testid": "create-api-user-success"
      });

      // TEMP not used. Will be uncommented in next task
      navigate(editApiUserRouteOnTab1(apiUser.id));
    } else {
      notifyError({
        header: "Could not create a new API user",
        "data-testid": "create-api-user-error"
      });
    }

    setInProgress(false);
  };

  return (
    <Page title={"Create API User"}>
      <div className="flex justify-end gap-6">
        <Button
          variant="ghost"
          size="big"
          onClick={() => {
            navigate(apiUsersRoute);
          }}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          size="big"
          disabled={createDisabled}
          isLoading={inProgress}
          onClick={onCreateCallback}
        >
          Create
        </Button>
      </div>
      <div className="flex">
        <Card className="w-[50%]">
          <Typography variant="smallTitle">Details</Typography>
          <div className="mt-6">
            <Input
              id={"new-api-user-name"}
              label="Name"
              onChange={e => {
                if (e.target.value?.length > 0) {
                  setCreateDisabled(false);
                  setApiUserName(e.target.value);
                }
              }}
            />
          </div>
        </Card>
      </div>
    </Page>
  );
};
